import {
  WbBreadcrumb,
  WbBreadcrumbs,
  WbHeader,
} from '@agilelab/plugin-wb-platform';
import { RoutedTabs } from '@mainstage/core-components';
import { useRouteRef, useRouteRefParams } from '@mainstage/core-plugin-api';

import { FC, useMemo, useState } from 'react';
import { roleDetailRouteRef, rolesPermissionsRouteRef } from '../../../routes';
import { AssignmentsTab } from '../Assignments/AssignmentsTab';
import { OverviewContextProvider } from './OverviewContext';
import { OverviewTab } from './OverviewTab';
import { WbPage } from '@agilelab/plugin-wb-platform';

export interface RoleDetailPageProps {}

export const RoleDetailPage: FC<RoleDetailPageProps> = ({}) => {
  const [name, setName] = useState<string>();
  const routes = useMemo(() => {
    const overviewSection = {
      path: '/overview',
      title: 'Role details',
      children: <OverviewTab />,
    };

    const assignmentsSection = {
      path: '/assignments',
      title: 'Assignments',
      children: <AssignmentsTab />,
    };

    return [overviewSection, assignmentsSection];
  }, []);
  const rolesPermissionsRoute = useRouteRef(rolesPermissionsRouteRef);
  const { roleId } = useRouteRefParams(roleDetailRouteRef);

  return (
    <WbPage themeId="home">
      <WbHeader
        title={name}
        titleContainerStyle={{ flex: 'none' }}
        breadcrumbs={
          <WbBreadcrumbs aria-label="breadcrumb">
            <WbBreadcrumb>Administration</WbBreadcrumb>
            <WbBreadcrumb to={rolesPermissionsRoute()}>
              Roles & Permissions
            </WbBreadcrumb>
            <WbBreadcrumb>{name} </WbBreadcrumb>
          </WbBreadcrumbs>
        }
      />
      <OverviewContextProvider roleId={roleId} setName={setName}>
        <RoutedTabs routes={routes} />
      </OverviewContextProvider>
    </WbPage>
  );
};
